import PropTypes from 'prop-types';

const StoreType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  phone_number: PropTypes.string.isRequired,
  region_name: PropTypes.string.isRequired,
  workroom_id: PropTypes.number.isRequired,
  workroom_name: PropTypes.string.isRequired,
  market_name: PropTypes.string,
  division_name: PropTypes.string,
  cpo_iso: PropTypes.string,
  disable_cpo_emails: PropTypes.bool.isRequired,
});

export default StoreType;



// WEBPACK FOOTER //
// ./client/app/shared/types/store.js